import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getOrderGeneratorsFieldsWorks(options={}) {
	return _apiRequestWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS,
		ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS].GET_ORDER_GENERATORS_FIELDS_WORKS,
		options
	)
}

function _getOrderGeneratorsFieldsWork(options={}) {
	return _apiRequestWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS,
		ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS].GET_ORDER_GENERATORS_FIELDS_WORK,
		options
	)
}

function _createOrderGeneratorsFieldsWork(options={}) {
	return _apiRequestWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS,
		ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS].CREATE_ORDER_GENERATORS_FIELDS_WORK,
		options
	)
}

function _putOrderGeneratorsFieldsWork(options={}) {
	return _apiRequestWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS,
		ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS].PUT_ORDER_GENERATORS_FIELDS_WORK,
		options
	)
}

function _patchOrderGeneratorsFieldsWork(options={}) {
	return _apiRequestWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS,
		ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS].PATCH_ORDER_GENERATORS_FIELDS_WORK,
		options
	)
}

function _deleteOrderGeneratorsFieldsWork(options={}) {
	return _apiRequestWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS,
		ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS].DELETE_ORDER_GENERATORS_FIELDS_WORK,
		options
	)
}

function _getOrderGeneratorsFieldsWorkPreview(options={}) {
	return _apiRequestWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS,
		ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS].GET_ORDER_GENERATORS_FIELDS_WORK_PREVIEW,
		options
	)
}

function _getOrderGeneratorsFieldsWorkPopup(options={}) {
	return _apiRequestWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS,
		ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS].GET_ORDER_GENERATORS_FIELDS_WORK_POPUP,
		options
	)
}

function _getOrderGeneratorsFieldsWorkRelatedPlanWorks(options={}) {
	return _apiRequestWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS,
		ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS].GET_ORDER_GENERATORS_FIELDS_WORK_RELATED_PLAN_WORKS,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS].GET_ORDER_GENERATORS_FIELDS_WORKS]: _getOrderGeneratorsFieldsWorks,

	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS].GET_ORDER_GENERATORS_FIELDS_WORK]: _getOrderGeneratorsFieldsWork,
	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS].GET_ORDER_GENERATORS_FIELDS_WORK_PREVIEW]: _getOrderGeneratorsFieldsWorkPreview,
	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS].GET_ORDER_GENERATORS_FIELDS_WORK_POPUP]: _getOrderGeneratorsFieldsWorkPopup,

	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS].CREATE_ORDER_GENERATORS_FIELDS_WORK]: _createOrderGeneratorsFieldsWork,
	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS].PUT_ORDER_GENERATORS_FIELDS_WORK]: _putOrderGeneratorsFieldsWork,
	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS].PATCH_ORDER_GENERATORS_FIELDS_WORK]: _patchOrderGeneratorsFieldsWork,
	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS].DELETE_ORDER_GENERATORS_FIELDS_WORK]: _deleteOrderGeneratorsFieldsWork,

	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS].GET_ORDER_GENERATORS_FIELDS_WORK_RELATED_PLAN_WORKS]: _getOrderGeneratorsFieldsWorkRelatedPlanWorks,
}